
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrderTiss, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class OrderTissDeclarationEditProvider {

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {}


    insert(orderTissDeclaration): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('order/order-tiss-declaration/', orderTissDeclaration)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                    },
                    error: (error: HttpResponse<any>) => {
                        reject(error);
                    }
                });
        });
    }

    update(orderTissDeclaration): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('order/order-tiss-declaration/', orderTissDeclaration)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                    },
                    error: (error: HttpResponse<any>) => {
                        reject(error);
                    }
                });
        });
    }

    delete(orderTissDeclarationId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete(`order/order-tiss-declaration/${orderTissDeclarationId}`)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                    },
                    error: (error: HttpResponse<any>) => {
                        reject(error);
                    }
                });
        });
    }


}
